import { render, staticRenderFns } from "./DialogTest.vue?vue&type=template&id=6d11408c"
import script from "./DialogTest.vue?vue&type=script&lang=js"
export * from "./DialogTest.vue?vue&type=script&lang=js"
import style0 from "./DialogTest.vue?vue&type=style&index=0&id=6d11408c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports